export default "__VITE_ASSET__CgQ6Ez8P__"